import mutations from './drugArchive.mutations'
import actions from './drugArchive.actions'
import getters from './drugArchive.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
